module.exports = __webpack_public_path__ + "static/media/jenn.a839f1f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/jenn.jpg
// module id = 612
// module chunks = 0